/**
 * The personas of the local dev auth bypass, one per dashboard role, by the
 * slug the backend's switch takes (`GET /api/auth/dev/persona/<slug>`): it
 * sets a cookie and sends the browser back to `/home` signed in as that
 * persona. The backend answers the switch, and `/auth/me` says `dev_bypass`,
 * only on a local machine with the bypass on; the account menu offers the
 * switch only then.
 */

import type { Role } from "@/lib/roles";

/** A persona: the slug the switch takes and the role it signs in with. */
export interface DevPersona {
  slug: string;
  role: Role;
}

/** The personas in the order the menu lists them, by rights: Lid first. */
export const DEV_PERSONAS: readonly DevPersona[] = [
  { slug: "lid", role: "user" },
  { slug: "beheerder", role: "admin" },
  { slug: "eigenaar", role: "owner" },
  { slug: "ontwikkelaar", role: "developer" },
];

/** Where the switch to a persona goes: a full-page link through the API proxy, never a fetch. */
export function personaHref(slug: string): string {
  return `/api/auth/dev/persona/${encodeURIComponent(slug)}`;
}

/** The persona the bypass signed in as, by the role `/auth/me` answers; null for another role. */
export function currentPersona(role: string | null | undefined): DevPersona | null {
  return DEV_PERSONAS.find((persona) => persona.role === role) ?? null;
}
